import Box from "@/components/Box";
import PartnerDashboardBox from "@/components/boxes/PartnerDashboardBox";
import { useOrganisationBasketContext } from "@/contexts/organisations/OrganisationBasketContext";
import Stack from "@/tpo/Stack";

export function basketHasDnaBaseTest(basket) {
  return basket?.productLineItems?.some(item => item.product?.isGenesTest) ?? false;
}

export default function DnaPreTestCounsellingAcknowledgement() {
  const { basket } = useOrganisationBasketContext();

  if (!basketHasDnaBaseTest(basket)) {
    return null;
  }

  return (
    <PartnerDashboardBox>
      <Stack gap={[24, 24, 28]}>
        <Box fontFamily="gilroyBold" fontSize={[24, 24, 28]}>
          Genetic test counselling
        </Box>
        <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
          The raw genetic data may include variants such as APOE (rs429358 and rs7412), which are
          associated with both cholesterol clearance and Alzheimer&apos;s disease risk. The
          Cardiometabolic report interprets only cholesterol clearance; Alzheimer&apos;s risk is not
          reported, but may still be identifiable from the raw data.
        </Box>
        <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
          By proceeding, you accept responsibility for appropriate pre-test counselling, including
          potential implications for the patient and their family, and acknowledge that this
          extends beyond the specific reports purchased.
        </Box>
      </Stack>
    </PartnerDashboardBox>
  );
}
